import { render, staticRenderFns } from "./historyReport.vue?vue&type=template&id=5707b987&scoped=true&"
import script from "./historyReport.vue?vue&type=script&lang=js&"
export * from "./historyReport.vue?vue&type=script&lang=js&"
import style0 from "./historyReport.vue?vue&type=style&index=0&id=5707b987&prod&scoped=true&lang=css&"
import style1 from "./historyReport.vue?vue&type=style&index=1&id=5707b987&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5707b987",
  null
  
)

export default component.exports